import { countryType } from "../../constant";



const countryReducer = (state = false, action) => {
    switch (action.type) {
        case countryType.FETCH_COUNTRIES:
            return action.payload;
        default:
            return state;
    }
}
export default countryReducer